import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAbroad = props => /*#__PURE__*/_jsx("svg", {
  viewBox: "0 0 24 24",
  width: "1em",
  height: "1em",
  ...props,
  children: /*#__PURE__*/_jsxs("g", {
    fill: "currentColor",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M12 1C7.786 1 4.361 4.467 4.361 8.733c0 1.44.395 2.848 1.142 4.068l6.064 9.894a.636.636 0 00.54.305h.003c.221 0 .429-.12.544-.314l5.907-9.988a7.802 7.802 0 001.078-3.96C19.639 4.466 16.214 1 12 1zm5.47 11.032l-5.372 9.082-5.513-8.996a6.505 6.505 0 01-.96-3.385C5.626 5.18 8.49 2.28 12 2.28s6.37 2.9 6.37 6.453a6.503 6.503 0 01-.9 3.3z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M12 4.667c-2.19 0-3.972 1.646-3.972 3.666C8.028 10.342 9.78 12 12 12c2.247 0 3.972-1.679 3.972-3.667 0-2.02-1.783-3.666-3.972-3.666zm0 6.119c-1.47 0-2.657-1.1-2.657-2.453 0-1.348 1.196-2.452 2.657-2.452s2.653 1.104 2.653 2.452c0 1.333-1.161 2.453-2.653 2.453z"
    })]
  })
});
export default SvgAbroad;